// extracted by mini-css-extract-plugin
export default {"column":"FooterColumn_column__k1Th8"};